{
  "es": {
    "ticket_category": {
      "Decisions": "Decisión",
      "Issue": "Posventa",
      "Regular": "General",
      "labels": {
        "ticket_category": "Tipo"
      }
    }
  }
}
